<template>
  <div
    class="app-content-container mx-auto h-full"
    :class="{'app-content-container-boxed': appContentWidth === 'boxed'}"
  >
    <slot></slot>
  </div>
</template>

<script>
import useLayoutConfig from '@/composable/useLayoutConfig'

export default {
  setup() {
    const { appContentWidth } = useLayoutConfig()

    return {
      appContentWidth,
    }
  },
}
</script>

<style lang="scss">
@import '~@/layouts/styles/_variables';

.app-content-container {
  &.app-content-container-boxed {
    max-width: $content-max-width;
  }
}
</style>
